module.exports = new Promise((resolve, reject) => {
  const script = document.createElement("script");
  // Всегда используем nginx proxy путь (работает и на dev, и на production)
  script.src = `${window.location.protocol}//${window.location.host}/admin-mf/remoteEntry.js`;
  script.onload = () => {
    const module = {
      get: (request) => window.admin.get(request),
      init: (arg) => {
        try {
          return window.admin.init(arg);
        } catch (e) {
          console.log("Admin remote has already been loaded");
        }
      },
    };
    resolve(module);
  };
  script.onerror = () => {
    reject(new Error('Admin remote init error'));
  };
  document.head.appendChild(script);
});